export enum KavaPageTypes {
  'View' = 1,
  'Create' = 2,
  'Edit' = 3,
  'Participate' = 4,
  'List' = 5,
  'Analytics' = 6,
  'Admin' = 7,
  'Error' = 8,
  'Login' = 9,
  'Registration' = 10,
  'Custom' = 11,
}

export const KavaEventPrefix = 'Fun___';
